import React from 'react';
import PropTypes from 'prop-types';
import Button from 'zignal-landscape/lib/Button';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Link from 'zignal-landscape/lib/Link';

import styles from './FormSubmissionControls.css';

export default function FormSubmissionControls({
  onCancel,
  onSubmit,
  submitButtonText = 'Create Custom Widget'
}) {

  return (
    <footer className={styles.wrapper}>
      <ButtonGroup>
        <Link linkType="cancel" onClick={onCancel}>
          Cancel
        </Link>
        <Button buttonStyle="positive" onClick={onSubmit}>
          {submitButtonText}
        </Button>
      </ButtonGroup>
    </footer>
  );
}

FormSubmissionControls.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string
};

